import { render, staticRenderFns } from "./ThirdPartyLogin.vue?vue&type=template&id=fc124af4&scoped=true&"
import script from "./ThirdPartyLogin.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyLogin.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartyLogin.vue?vue&type=style&index=0&id=fc124af4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc124af4",
  null
  
)

export default component.exports